import axios from 'axios'

import AscentiaService from './ascentiaService'

const values = {
  users: null,
  user: null,
  createUser: null,
  updateUserEmailSubscriptions: null,
  emailSubscriptionTypes: null,
  emailSubscriptionById: null,
  reportTypesData: null,
  adminMasterModels: null,
}

const getters = {
  users() {
    return axios.get('/admin/users')
  },
  emailSubscriptionTypes() {
    return axios.get(
      '/EmailSubscriptions/types',
    )
  },
  emailSubscriptionById(userId) {
    return axios.get(
      `/admin/user/${userId}/emailsubscriptions`,
    )
  },
  reportTypesData() {
    const url = '/admin/AllReportTypes'
    return axios.get(url)
  },
  adminMasterModels() {
    const url = '/admin/AllMasterModels'
    return axios.get(url)
  },
}

const saves = {
  user(user) {
    return axios.put(`/admin/user/${user.userId}`, user)
  },
  createUser(user) {
    return axios.post(`/admin/user/okta`, user)
  },
  updateUserEmailSubscriptions(userEmailSubscriptions) {
    return axios.put(
      `/admin/user/${userEmailSubscriptions.userId}/emailsubscriptions`,
      userEmailSubscriptions.subscriptions,
    )
  },
}

const deletes = {
  deleteUserEmailSubscription(
    removeUserEmailSubscription,
  ) {
    if (
      removeUserEmailSubscription.userId &&
      removeUserEmailSubscription.subscriptionId
    ) {
      return axios.delete(
        `/admin/user/${removeUserEmailSubscription.userId}/emailSubscriptions/${removeUserEmailSubscription.subscriptionId}`,
      )
    }

    return false
  },
}

export default class AdminService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
